export default __webpack_public_path__ + "static/media/ag_2.8fbcf950.wav";